import EditCustomer from './EditCustomer';

export default EditCustomer;